import { render } from "./BaseFieldCheckbox.vue?vue&type=template&id=75b690a4"
import script from "./BaseFieldCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseFieldCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__